export const getValidImageFormats = (): string[] => {
    return [
        'image/jpeg',
        'image/png',
        'image/jpg',
        'image/gif',
        'image/svg+xml',
        'image/webp'
    ];
};